import React from 'react'
import { createGlobalStyle, ThemeProvider } from 'styled-components'

// Extract our Sass variables into a JS object
// eslint-disable-next-line import/no-webpack-loader-syntax
const theme = require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!../Resources/styles/config.scss')

export type ThemeType = typeof theme

type ThemeProps = {
  //
}

const GlobalStyle = createGlobalStyle<{ theme: ThemeType }>`
  a {
    color: ${(props) => props.theme.baseLinkColor};
  }
`

export const Theme: React.FC<ThemeProps> = ({ children }) => (
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    {children}
  </ThemeProvider>
)
